/** @format */

import React from "react";
import MainContentView from "./MainContent.view";

interface IRegistrationFormProps {
	sitekey: string;
	onSuccess: () => void;
}

const MainContentContainer: React.FC<IRegistrationFormProps> = ({
	sitekey,
	onSuccess,
}) => {
	return <MainContentView sitekey={sitekey} onSuccess={onSuccess} />;
};

export default MainContentContainer;
